<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-height="680"
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >
    <v-card v-cloak>
        <v-card-title class="d-flex justify-space-between">
        {{ $t('console.promoteOwner') }}

        <v-btn icon @click="dialog = false;">
            <v-icon>mdi-close</v-icon>
        </v-btn>
        </v-card-title>

        <v-card-text scrollable class="scrollable">
          <v-form @submit.prevent="submitForm" ref="form">
            <div class="mt-4">
              <p>
                {{ $t('console.promoteOwnerDescription') }}
              </p>
              <p>
                {{ $t('console.promoteOwnerDescription2') }}
              </p>
              <p>
                {{ $t('console.promoteOwnerDescription3') }}
              </p>
            </div>

            <div class="mt-4">
              <p>
                {{ $t('console.selectUserToPromote') }}
              </p>

              <v-select
                v-model="selectedUser"
                :items="userItems"
                :rules="selectedUserRules"
                item-title="name"
                item-value="id"
                variant="solo-filled" flat
                hide-details="auto"
              >

              </v-select>
            </div>

            <div class="mt-4">
              <p>
                {{ $t('console.typePromote') }}
              </p>

              <v-text-field
                v-model="promoteTenantText"
                variant="solo-filled" flat
                class="mt-4"
                hide-details="auto"
              />
            </div>

            <v-row class="mt-4">
              <v-col>
                <div v-if="errorMessage" class="bg-error mb-4" style="width: 100%;">
                  {{ errorMessage }}
                </div>
                <div v-if="isSuccess" class="bg-success mb-4" style="width: 100%;">
                  {{ $t('console.promoteOwnerSuccess') }}
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>


        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn type="submit" class="bg-primary" elevation=0 @click="submitForm()"
                v-bind:loading="isSubmitted" v-bind:disabled="isDisabled">
            {{ $t('console.promote') }}
        </v-btn>
        <v-btn variant="text" @click="dialog = false">{{ $t('common.close') }}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js';
import { useUserStore } from '@/stores/UserStore.js';
import { useTenantStore } from '@/stores/TenantStore.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [ DialogActionKeys, DialogModel ],
  name: 'DeleteTenantDialog',
  data() {
    return {
      isSubmitted: false,
      isSuccess: false,

      errorMessage: '',
      successMessage: '',

      selectedUser: '',
      selectedUserRules: [
        v => !!v || this.$t('routes.apiClients.userRequired')
      ],

      promoteTenantText: "",
    };
  },
  watch: {
    dialog: function(newValue) {
      if (newValue) {
        this.resetForm();
      }
    }
  },
  methods: {
    resetForm() {
      this.isSubmitted = false;
      this.isSuccess = false;
      this.errorMessage = '';
      this.successMessage = '';

      this.selectedUser = '';
      this.promoteTenantText = '';

      this.refreshUsersList();
    },
    async refreshUsersList() {
      const userStore = useUserStore();
      await userStore.refreshUsers({ accessPointId: this.rootNodeId });
    },
    async submitForm() {
      this.errorMessage = '';
      this.successMessage = '';

      const { valid } = await this.$refs.form.validate();

      if (!valid || this.isDisabled) {
        return;
      }

      try {
        this.isSubmitted = true;

        const tenantStore = useTenantStore();
        await tenantStore.promoteOwner(this.rootNodeId, this.selectedUser);

        this.isSuccess = true;

        setTimeout(() => {
          this.$router.push('/account/logout');
        }, 3000);
      } catch (error) {
        console.error(error);

        if (error?.response?.data?.error) {
          this.errorMessage = this.$localizeMessage(error.response.data.error);
        } else {
          this.errorMessage = this.$t('backend.system-error');
        }
      } finally {
        this.isSubmitted = false;
      }
    },
  },
  computed: {
    rootNodeId: function () {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    users: function() {
      const userStore = useUserStore();
      return userStore.getUsers
        .filter(x => x.deletedat === null)
        .filter(x => x.expiredat === null)
        .filter(x => x.id !== this.currentUser?.id)
        .filter(x => (x.abilities || []).find(ability => ability.action === 'belongsto' && ability.subject === 'Team'))
    },
    currentUser() {
      const authStore = useAuthStore();
      return authStore.dbUser;
    },
    userItems() {
      return this.users.map(function(u) {
        return {
          id: u.id,
          name: `${u.name} (${u.email})`
        };
      });
    },
    isDisabled() {
      return this.isSubmitted
          || (this.promoteTenantText.toLowerCase() !== "promote");
    },
  }
}
</script>

<style>
</style>
